/**
 * Base path for all API endpoints.
 * Centralizes API routing to prevent hardcoded paths across the application.
 */

export const API_BASE = '/api'


/**
 * API endpoint constants for authentication and user management.
 * Provides type-safe endpoint definitions for consistent API communication.
 */

export const ENDPOINTS = {
    AUTH: {
        SIGNUP: `${API_BASE}/auth/signup`,
        LOGIN: `${API_BASE}/auth/login`,
        LOGOUT: `${API_BASE}/auth/logout`,
        VERIFY_EMAIL: `${API_BASE}/auth/verify-email`,
        RESEND_VERIFICATION: `${API_BASE}/auth/resend-verification`,
        ME: `${API_BASE}/auth/me`,
        REQUEST_PASSWORD_RESET: `${API_BASE}/auth/request-password-reset`,
        RESET_PASSWORD: `${API_BASE}/auth/reset-password`,
        VALIDATE_RESET_TOKEN: `${API_BASE}/auth/validate-reset-token`,
        ACCOUNTS: `${API_BASE}/auth/accounts`,
    },
} as const


/**
 * Client-side route paths for React Router navigation.
 * Ensures consistent routing throughout the dashboard application.
 */

export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    SIGNUP: '/signup',
    VERIFY_EMAIL: '/verify-email',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    DASHBOARD: '/dashboard',
    SECURITY: '/security',
    ACCOUNTS: '/accounts',
    ACCOUNT: '/dashboard/:username', // Dynamic route for specific account
    VIDEO_DETAIL: '/dashboard/:username/video/:videoId', // Dynamic route for video detail
} as const

/**
 * Helper to generate account-specific route
 */
export const getAccountRoute = (username: string) => `/dashboard/${username}`
